import catalogRedux from '../../catalog/redux/reducer'

//export redux objects
export default {
	catalogRedux
};
